// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"StoppingAreaScreen_buttonsContainer__vy-YK","button":"StoppingAreaScreen_button__IJdJR"};